/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Selectors for SettingsLabels component
 *
 * @author Aleksandr Perkhunov
 * @version 1.3.1
 * @since 1.3.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../reducers/rootReducer';
import { ISettingsLabelsState } from './settingsLabelsReducer';
import { ISettingsLabelsItem } from './settingsLabelsTypes';

export const makeSelectSettingsLabels = (state: IRootReducer): ISettingsLabelsState => state.settings.settingsLabels;

export const makeSelectSettingsLabelsIsLoading = ():
    OutputSelector<IRootReducer, boolean, (state: ISettingsLabelsState) => boolean> =>
    createSelector(makeSelectSettingsLabels, (state) => state.isLoading);

export const makeSelectSettingsLabelsList = ():
    OutputSelector<IRootReducer, ISettingsLabelsItem[], (state: ISettingsLabelsState) => ISettingsLabelsItem[]> =>
    createSelector(makeSelectSettingsLabels, (state) => state.list);

export const makeSelectSettingsLabelsListSearch = ():
    OutputSelector<IRootReducer, string, (state: ISettingsLabelsState) => string> =>
    createSelector(makeSelectSettingsLabels, (state) => state.search);

export const makeSelectSettingsLabelsListHasMore = ():
    OutputSelector<IRootReducer, boolean, (state: ISettingsLabelsState) => boolean> =>
    createSelector(makeSelectSettingsLabels, (state) => state.hasMore);
